import api from "./api";
import UtilsUrl from "../utils/UtilsUrl";

class DocumentService {
  getDevisByRef(idUser, refDevis) {
    return api.get(
      UtilsUrl.documentURL() + "/getDevisByRef/" + idUser + "/" + refDevis
    );
  }

    updateBDCFournisseur(idUser, refBdc,idFournisseur) {
    return api.get(
      UtilsUrl.documentURL() + "/updateBDCFournisseur/" + idUser + "/" + refBdc+ "/" + idFournisseur
    );
  }
      updateFactureFournisseur(idUser, ref,idFournisseur) {
    return api.get(
      UtilsUrl.documentURL() + "/updateFactureFournisseur/" + idUser + "/" + ref+ "/" + idFournisseur
    );
  }
  addRateToBdc(rateModel) {
    return api.post(UtilsUrl.documentURL() + "/addRateToBdc", rateModel);
  }
  addRateToDevis(rateModel) {
    return api.post(UtilsUrl.documentURL() + "/addRateToDevis", rateModel);
  }
  addRateToFacture(rateModel) {
    return api.post(UtilsUrl.documentURL() + "/addRateToFacture", rateModel);
  }
}
export default new DocumentService();
